import React, { useEffect, useState } from "react";
import Button from "antd/lib/button";
import Input from "antd/lib/input";
import Radio from "antd/lib/radio";
import Popover from "antd/lib/popover";

import { useDispatch, useSelector } from "react-redux";
import { setWidgitDescription } from "../../../../../redux/actions/section/section";
import EditIcon from "../../../../../assets/Template/Edit_icon.svg";
import isEqual from "react-fast-compare";

const { TextArea } = Input;
const WidgetDescription = ({
  section_index,
  widget_index,
  addDescription,
  widget_id,
  openPopover,
  widgetData,
  openPopoverWidgetDesc,
  setOpenPopoverWidgetDesc,
}) => {
  const dispatch = useDispatch();
  const Section = useSelector((state) => state.Section.addSection);
  //**** Widget description START ****

  const [widgetDescriptions, setWidgetDescriptions] = useState(
    widgetData?.widget_description
  );

  const [widgetDescRedioStatus, setWidgetDescRedioStatus] = useState(
    widgetData?.widget_description_on_icon === undefined
      ? true
      : widgetData?.widget_description_on_icon
  );
  //**** Widget description END ****

  const handleWidgetDecOpenChange = (status, widget_index, mode) => {
    setOpenPopoverWidgetDesc({
      openStatus: status,
      id: widget_index,
      view: mode,
    });
  };
  const widgetdescSave = (e, widget_id) => {
    setOpenPopoverWidgetDesc({ openStatus: false, id: widget_id });
    if (e === "save") {
      dispatch(
        setWidgitDescription(
          widgetDescriptions?.trim(),
          widgetDescRedioStatus,
          Section,
          section_index,
          widget_index
        )
      );
      setWidgetDescriptions(widgetData?.widget_description?.trim());
    } else if (e === "clear") {
      setWidgetDescRedioStatus(true);
      setWidgetDescriptions(null);
      dispatch(
        setWidgitDescription(null, true, Section, section_index, widget_index)
      );
    } else if (e === "cancel") {
      setWidgetDescRedioStatus(
        widgetData?.widget_description_on_icon === undefined
          ? true
          : widgetData?.widget_description_on_icon
      );
      setWidgetDescriptions(widgetData?.widget_description?.trim());
    }
  };
  const onClose = (e) => {
    setOpenPopoverWidgetDesc({
      openStatus: false,
      id: null,
      view: null,
    });
  };

  // useEffect(() => {
  //   // document.addEventListener("click", onOpen, true);
  //   document.addEventListener("scroll", onClose, true);
  //   return () => {
  //     // document.removeEventListener("click", onOpen, true);
  //     document.removeEventListener("scroll", onClose, true);
  //   };
  // }, []);
  return (
    <>
      <Popover
        content={
          <>
            <div className="p-15" style={{ minWidth: "35rem" }}>
              <div className="floating-label-group header-brands mt-1">
                <TextArea
                  className="border-color"
                  defaultValue={widgetData?.widget_description}
                  rows={4}
                  maxLength={150}
                  value={widgetDescriptions}
                  //placeholder="maxLength is 6"

                  onChange={(e) =>
                    setWidgetDescriptions(e?.target?.value, widget_id)
                  }
                />
                <label
                  className="portlet-label floating-label"
                  style={{ top: "-1rem" }}
                >
                  Enter Description
                </label>
                <span
                  style={{ bottom: "-0.5rem", right: "0.5rem" }}
                  className="text-gray position-absolute font-size12"
                >
                  {widgetDescriptions === "" || widgetDescriptions
                    ? widgetDescriptions?.length
                    : widgetData?.widget_description
                    ? widgetData?.widget_description?.length
                    : 0}
                  /150
                </span>
              </div>

              <div className="mt-15">
                <Radio.Group
                  defaultValue={true}
                  value={widgetDescRedioStatus}
                  onChange={(e) => setWidgetDescRedioStatus(e?.target?.value)}
                >
                  <div className="mb-2">
                    <Radio
                      className="text_regular-gray font-size14"
                      value={true}
                    >
                      Incorporate a description within{" "}
                      <i className="fa fa-info-circle" /> icon
                    </Radio>
                  </div>
                  <Radio
                    className="text_regular-gray font-size14"
                    value={false}
                  >
                    Include a description below the title
                  </Radio>
                </Radio.Group>
              </div>
            </div>

            <div className=" p-2 border-top border-color d-flex justify-content-between">
              <Button
                onClick={() => widgetdescSave("clear", widget_id)}
                className="btn_Clear"
              >
                Clear
              </Button>
              <div className="">
                <Button
                  //type="link"
                  onClick={() => widgetdescSave("cancel", widget_id)}
                  className="btn_Clear cursor-pointer"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => widgetdescSave("save", widget_id)}
                  className="ant-btn-primary_blue cursor-pointer ml-15"
                >
                  Save
                </Button>
              </div>
            </div>
          </>
        }
        title={null}
        trigger="click"
        placement="bottom"
        visible={
          openPopoverWidgetDesc?.view === "edit" ||
          openPopoverWidgetDesc?.view === "addDesc"
            ? openPopoverWidgetDesc?.openStatus
            : false
        }
        onVisibleChange={(e) =>
          handleWidgetDecOpenChange(
            !widgetData?.widget_description ? e : true,
            widget_id,
            !widgetData?.widget_description ? "addDesc" : "edit"
          )
        }
      >
        {addDescription ? (
          <span
            className={`cursor-pointer blue-text font-weight400 ml-1 mr-1 fontSize-14 ${
              openPopoverWidgetDesc?.openStatus || openPopover ? "disable" : ""
            }`}
          >
            + Add Description
          </span>
        ) : (
          <img
            src={EditIcon}
            alt="edit_icon"
            className={`edit-name description_edit_icon ml-1 mr-1 cursor-pointer ${
              openPopoverWidgetDesc?.openStatus || openPopover ? "disable" : ""
            }`}
            onClick={() => handleWidgetDecOpenChange(true, widget_id, "edit")}
          />
        )}
      </Popover>
    </>
  );
};

export default React.memo(WidgetDescription, isEqual);
